import { executeReport, REPORT_TYPES } from '../../../../../../../../../../logic/utils/reportRequest';

export default async function SqlQuery() {
  return executeReport(REPORT_TYPES.OPERATOR_LIST, {});
}
